// import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { RequestLeave } from '../../action/Leave';
// import { getLeaveTypeByUser } from '../../action/LeaveType';
// import {
//   Plus, Search, ChevronDown, X, User, Calendar,
//   Hash, BadgeCheck, Stethoscope, Mail, Layers,
//   AlertCircle, Loader2, ArrowLeft, CheckCircle, Sun, Phone, Info, Upload, File, Trash2, RefreshCw
// } from 'lucide-react';
// import leaveService from '../../services/LeaveService';

// // ─── HELPERS ────────────────────────────────────────────────────────────

// const getAuth = () => localStorage.getItem('auth-key') || '';


// /**
//  * Convert ISO date (YYYY-MM-DD) to (YYYY/MM/DD)
//  */
// const toBackendDate = (isoDate) => {
//   if (!isoDate) return '';
//   const [y, m, d] = isoDate.split('-');
//   if (!y || !m || !d) return isoDate;
//   return `${y}/${m}/${d}`;
// };

// /**
//  * Format date for display (YYYY/MM/DD)
//  */
// const formatDateForDisplay = (dateStr) => {
//   if (!dateStr) return '';
//   if (dateStr.includes('/')) return dateStr;
//   const parts = dateStr.split('-');
//   if (parts.length === 3) {
//     return `${parts[0]}/${parts[1]}/${parts[2]}`;
//   }
//   return dateStr;
// };

// /**
// * Generate random 8-digit form number
// */
// const generateFormNo = () => {
//   const min = 10000000;
//   const max = 99999999;
//   return String(Math.floor(Math.random() * (max - min + 1)) + min);
// };

// /**
//  * Format string value - remove null/undefined/empty
//  */
// const fmt = (v) => (!v || v === 'null') ? '' : String(v).trim();

// /**
//  * Format balance numbers - remove unnecessary decimals
//  */
// const fmtBalance = (n) => {
//   if (n === null || n === undefined || Number.isNaN(n)) return '';
//   return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.?0+$/, '');
// };

// /**
//  * Get year options for dropdown
//  */
// const getYearOptions = () => {
//   const currentYear = new Date().getFullYear();
//   const years = [];
//   for (let year = currentYear; year >= 2020; year--) {
//     years.push(year);
//   }
//   return years;
// };

// /**
//  * Validate phone number - must be 10 digits
//  */
// const validatePhone = (value) => {
//   if (!value) return 'Contact No. is required';
//   if (!/^\d+$/.test(value)) {
//     return 'Contact No. must contain only numbers';
//   }
//   if (value.length !== 10) {
//     return 'Contact No. must contain exactly 10 numbers';
//   }
//   return '';
// };


// /**
//  * Validate leave days against available balance
//  */
// const validateLeaveDays = (daysValue, leaveType) => {
//   if (daysValue === '' || daysValue === null || daysValue === undefined) {
//     return 'Leave Days is required';
//   }

//   const numValue = Number(daysValue);

//   if (Number.isNaN(numValue)) {
//     return 'Leave Days must be a number';
//   }

//   if (numValue <= 0) {
//     return 'Leave Days must be greater than 0';
//   }

//   if (leaveType && leaveType.balance !== null && !Number.isNaN(leaveType.balance)) {
//     if (numValue > leaveType.balance) {
//       return `Only ${fmtBalance(leaveType.balance)} day${leaveType.balance === 1 ? '' : 's'} available for ${leaveType.name}`;
//     }
//   }

//   return '';
// };


// // ─── CSS CLASSES ──────────────────────────────────────────────────────

// const INP = "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 bg-gray-50 focus:bg-white transition-colors";
// const SEL = INP + " appearance-none";
// const LBL = "block text-[11px] font-semibold text-gray-600 mb-1 uppercase tracking-wide";

// // ─── COMPONENTS ──────────────────────────────────────────────────────

// /**
//  * Employee Search Dropdown Component
//  */
// function EmpSearch({ value, onChange, employees, placeholder = 'Search employee...' }) {
//   const [q, setQ] = useState('');
//   const [open, setOpen] = useState(false);
//   const ref = useRef();

//   const filtered = useMemo(() => {
//     if (!q) return employees;
//     const lq = q.toLowerCase();
//     return employees.filter(e =>
//       fmt(e.p_ced_service_no).toLowerCase().includes(lq) ||
//       `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.toLowerCase().includes(lq) ||
//       fmt(e.p_report_name).toLowerCase().includes(lq)
//     );
//   }, [employees, q]);

//   const selected = employees.find(e => fmt(e.p_ced_service_no) === value);
//   const displayName = selected
//     ? `${fmt(selected.p_ced_service_no)} — ${fmt(selected.p_report_name) || `${fmt(selected.p_first_name)} ${fmt(selected.p_last_name)}`}`
//     : '';

//   useEffect(() => {
//     const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
//     document.addEventListener('mousedown', handler);
//     return () => document.removeEventListener('mousedown', handler);
//   }, []);

//   return (
//     <div ref={ref} className="relative">
//       <div className={`${INP} flex items-center gap-2 cursor-pointer`} onClick={() => setOpen(v => !v)}>
//         <User size={13} className="text-gray-400 shrink-0" />
//         <span className={`flex-1 text-sm truncate ${value ? 'text-gray-800' : 'text-gray-400'}`}>
//           {value ? displayName : placeholder}
//         </span>
//         <ChevronDown size={12} className={`text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />
//       </div>
//       {open && (
//         <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-xl shadow-xl z-50">
//           <div className="p-2 border-b border-gray-100">
//             <div className="relative">
//               <Search size={12} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
//               <input
//                 autoFocus
//                 value={q}
//                 onChange={e => setQ(e.target.value)}
//                 placeholder="Name or service no..."
//                 className="w-full pl-7 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary-300"
//               />
//             </div>
//           </div>
//           <div className="max-h-52 overflow-y-auto py-1">
//             {filtered.length === 0
//               ? <p className="text-center text-[12px] text-gray-400 py-3">No results</p>
//               : filtered.map(e => {
//                 const sno = fmt(e.p_ced_service_no);
//                 const name = fmt(e.p_report_name) || `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.trim();
//                 return (
//                   <button
//                     key={sno}
//                     onClick={() => { onChange(sno, e); setOpen(false); setQ(''); }}
//                     className={`w-full flex items-center gap-2.5 px-3 py-2 hover:bg-primary-50 transition-colors text-left ${value === sno ? 'bg-primary-50 text-primary-700' : ''}`}
//                   >
//                     <span className="text-[11px] font-mono text-gray-400 w-16 shrink-0">{sno}</span>
//                     <span className="text-[12px] text-gray-800 truncate">{name}</span>
//                   </button>
//                 );
//               })}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// /**
//  * Date Picker with YYYY/MM/DD Format
//  */
// function DatePickerWithFormat({ value, onChange, label, required = false, disabled = false, placeholder = 'YYYY/MM/DD' }) {
//   const dateInputRef = useRef(null);
//   const [displayValue, setDisplayValue] = useState('');

//   useEffect(() => {
//     setDisplayValue(formatDateForDisplay(value));
//   }, [value]);

//   const handleTextChange = (e) => {
//     let input = e.target.value.replace(/\//g, '');
//     let formatted = '';

//     if (input.length > 0) {
//       if (input.length <= 4) {
//         formatted = input;
//       } else if (input.length <= 6) {
//         formatted = `${input.slice(0, 4)}/${input.slice(4)}`;
//       } else {
//         formatted = `${input.slice(0, 4)}/${input.slice(4, 6)}/${input.slice(6, 8)}`;
//       }
//     }

//     setDisplayValue(formatted);

//     const parts = formatted.split('/');
//     if (parts.length === 3 && parts[0].length === 4 && parts[1].length === 2 && parts[2].length === 2) {
//       onChange(`${parts[0]}-${parts[1]}-${parts[2]}`);
//     }
//   };

//   const openCalendar = () => {
//     if (!disabled && dateInputRef.current) {
//       dateInputRef.current.showPicker?.();
//     }
//   };

//   const handleDatePickerChange = (e) => {
//     onChange(e.target.value);
//   };

//   return (
//     <div>
//       <label className={LBL}>
//         {label} {required && '*'}
//       </label>
//       <div className="relative">
//         <input
//           ref={dateInputRef}
//           type="date"
//           className="absolute opacity-0 w-0 h-0 pointer-events-none"
//           value={value || ''}
//           onChange={handleDatePickerChange}
//           disabled={disabled}
//         />
//         <div className="relative">
//           <input
//             type="text"
//             className={`${INP} pr-10 ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'cursor-pointer'}`}
//             value={displayValue}
//             onChange={handleTextChange}
//             onClick={openCalendar}
//             placeholder={placeholder}
//             disabled={disabled}
//             maxLength={10}
//             readOnly={disabled}
//           />
//           <button
//             type="button"
//             onClick={openCalendar}
//             className={`absolute right-3 top-1/2 -translate-y-1/2 transition-colors ${disabled ? 'text-gray-300 cursor-not-allowed' : 'text-gray-400 hover:text-gray-600'
//               }`}
//             disabled={disabled}
//           >
//             <Calendar size={18} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// /**
//  * File Upload Component with Drag & Drop
//  */
// function FileUpload({ value, onChange, onRemove, accept = '.pdf,.doc,.docx,.jpg,.jpeg,.png', maxSize = 5 }) {
//   const [dragOver, setDragOver] = useState(false);
//   const [uploadError, setUploadError] = useState('');
//   const fileInputRef = useRef(null);

//   const handleFileSelect = (file) => {
//     setUploadError('');

//     if (file.size > maxSize * 1024 * 1024) {
//       setUploadError(`File size exceeds ${maxSize}MB limit.`);
//       return;
//     }

//     const fileType = file.type;
//     const validTypes = accept.split(',').map(t => t.trim());
//     const isValidType = validTypes.some(type => {
//       if (type.startsWith('.')) {
//         return file.name.toLowerCase().endsWith(type.toLowerCase());
//       }
//       return fileType.includes(type.replace('*', ''));
//     });

//     if (!isValidType) {
//       setUploadError(`Invalid file type. Accepted: ${accept}`);
//       return;
//     }

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       onChange({
//         file: file,
//         name: file.name,
//         size: file.size,
//         type: file.type,
//         data: e.target.result,
//         lastModified: file.lastModified
//       });
//     };
//     reader.onerror = () => {
//       setUploadError('Failed to read file.');
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setDragOver(false);
//     const file = e.dataTransfer.files[0];
//     if (file) {
//       handleFileSelect(file);
//     }
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     setDragOver(true);
//   };

//   const handleDragLeave = (e) => {
//     e.preventDefault();
//     setDragOver(false);
//   };

//   const handleClick = () => {
//     fileInputRef.current?.click();
//   };

//   const formatFileSize = (bytes) => {
//     if (bytes === 0) return '0 Bytes';
//     const k = 1024;
//     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//     const i = Math.floor(Math.log(bytes) / Math.log(k));
//     return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
//   };


//   return (
//     <div className="space-y-2">
//       {!value ? (
//         <div
//           onClick={handleClick}
//           onDrop={handleDrop}
//           onDragOver={handleDragOver}
//           onDragLeave={handleDragLeave}
//           className={`border-2 border-dashed rounded-lg p-4 text-center cursor-pointer transition-colors
//             ${dragOver ? 'border-primary-400 bg-primary-50' : 'border-gray-300 hover:border-primary-400 hover:bg-gray-50'}`}
//         >
//           <input
//             ref={fileInputRef}
//             type="file"
//             accept={accept}
//             onChange={(e) => {
//               if (e.target.files && e.target.files[0]) {
//                 handleFileSelect(e.target.files[0]);
//               }
//               e.target.value = '';
//             }}
//             className="hidden"
//           />
//           <Upload size={24} className="mx-auto text-gray-400 mb-2" />
//           <p className="text-sm text-gray-600">Click or drag to upload attachment</p>
//           <p className="text-xs text-gray-400 mt-1">Accepted: {accept} (max {maxSize}MB)</p>
//           {uploadError && (
//             <p className="text-xs text-red-600 mt-2">{uploadError}</p>
//           )}
//         </div>
//       ) : (
//         <div className="flex items-center gap-3 p-3 bg-gray-50 border border-gray-200 rounded-lg">
//           <File size={20} className="text-primary-500 shrink-0" />
//           <div className="flex-1 min-w-0">
//             <p className="text-sm font-medium text-gray-800 truncate">{value.name}</p>
//             <p className="text-xs text-gray-500">{formatFileSize(value.size)}</p>
//           </div>
//           <button
//             onClick={onRemove}
//             className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
//             title="Remove file"
//           >
//             <Trash2 size={16} />
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

// /**
//  * Success Modal
//  */
// function SuccessModal({ isOpen, message, onClose }) {
//   if (!isOpen) return null;
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6 transform transition-all">
//         <div className="flex flex-col items-center text-center">
//           <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
//             <CheckCircle size={32} className="text-emerald-600" />
//           </div>
//           <h3 className="text-xl font-bold text-gray-900 mb-2">Success!</h3>
//           <p className="text-gray-600 text-sm mb-6">{message || 'Leave request submitted successfully!'}</p>
//           <button
//             onClick={onClose}
//             className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors"
//           >
//             OK
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// /**
//  * Error Modal
//  */
// function ErrorModal({ isOpen, message, onClose }) {
//   if (!isOpen) return null;
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6 transform transition-all">
//         <div className="flex flex-col items-center text-center">
//           <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
//             <AlertCircle size={32} className="text-red-600" />
//           </div>
//           <h3 className="text-xl font-bold text-gray-900 mb-2">Error</h3>
//           <p className="text-gray-600 text-sm mb-6">{message || 'Failed to submit leave request'}</p>
//           <button
//             onClick={onClose}
//             className="px-6 py-2.5 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors"
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── MAIN COMPONENT ────────────────────────────────────────────────────

// /**
//  * Leave Request Form
//  * Allows employees to submit leave requests with validation and duplicate checking
//  */
// export default function LeaveAdd() {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { employees } = useSelector(s => s.employees);
//   const authUser = useSelector(s => s.auth.user);
//   const userId = authUser?.raw?.ADU_EmployeeId || authUser?.serviceNo || '';

//   // ─── Employee Options ──────────────────────────────────────────────
//   const employeeOptions = useMemo(() => {
//     return (employees || []).map(emp => ({
//       ...emp,
//       p_ced_service_no: emp.p_ced_service_no || emp.HED_SERVICE_NO || emp.HED_CED_SERVICE_NO || '',
//       p_first_name: emp.p_first_name || emp.HED_FIRST_NAME || '',
//       p_last_name: emp.p_last_name || emp.HED_LAST_NAME || '',
//       p_report_name: emp.p_report_name || emp.HED_REPORT_NAME || '',
//       p_barcode: emp.p_barcode || emp.HED_SERVICE_NO || '',
//       p_location_code: emp.p_location_code || emp.HED_LOCATION_ID || '',
//       p_department_code: emp.p_department_code || emp.HDD_DEPARTMENT_CODE || '',
//       p_division_code: emp.p_division_code || emp.HED_GROUP || '',
//     }));
//   }, [employees]);

//   const today = new Date().toISOString().split('T')[0];

//   // ─── Form State ─────────────────────────────────────────────────────
//   const [form, setForm] = useState({
//     p_hlf_leaveform_no: generateFormNo(),
//     p_hlf_barcode_no: '',
//     p_hlf_service_no: '',
//     p_hlf_reason: '',
//     p_hlf_leave_type: '',
//     p_hlf_leave_days: '1',
//     p_hlf_start_date: today,
//     p_hlf_end_date: today,
//     p_hlf_div_code: '',
//     p_hlf_dep_code: '',
//     p_hlf_loc_code: '',
//     p_hlf_contact_no: '',
//     p_hlf_attachment_path: '',
//     p_acting_officer: '',
//     p_supervising_officer: '',
//     p_authorizing_officer: '',
//     p_hlf_leave_status: 'P',
//     p_hlf_approved_status: 'N',
//     p_hlf_medical_certificate: 'N',
//     p_hlf_generate_email: 'Y',
//     p_hlf_year: String(new Date().getFullYear()),
//     p_hlf_setoff_status: 'N',
//     p_hlf_mc_status: 'N',
//     p_hlf_is_half_day: 'N',
//     p_hlf_half_day_session: '',
//   });

//   const [attachment, setAttachment] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const [leaveTypes, setLeaveTypes] = useState([]);
//   const [loadingLeaveTypes, setLoadingLeaveTypes] = useState(false);
//   const [leaveTypeInfo, setLeaveTypeInfo] = useState('');
//   const [leaveDaysError, setLeaveDaysError] = useState('');
//   const [duplicateError, setDuplicateError] = useState('');
//   const [isValidatingFormNo, setIsValidatingFormNo] = useState(false);
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [showErrorModal, setShowErrorModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState('');

//   const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

//   const showError = (msg) => {
//     setError(msg);
//     setModalMessage(msg);
//     setShowErrorModal(true);
//   };

//   const selectedLeaveType = useMemo(
//     () => leaveTypes.find(t => t.code === form.p_hlf_leave_type) || null,
//     [leaveTypes, form.p_hlf_leave_type]
//   );

//   // ─── Duplicate Check Helpers ───────────────────────────────────────
//   const BLOCKING_STATUSES_TO_SKIP = ['CANCELLED', 'REJECTED', 'DECLINED'];


//   const parseToComparableDate = (dateStr) => {
//     if (!dateStr) return null;
//     const cleaned = String(dateStr).trim();
//     if (/^\d{8}$/.test(cleaned)) {
//       return new Date(`${cleaned.slice(0, 4)}-${cleaned.slice(4, 6)}-${cleaned.slice(6, 8)}`);
//     }
//     const parsed = new Date(cleaned);
//     return Number.isNaN(parsed.getTime()) ? null : parsed;
//   };

//   const checkDuplicateLeave = async (serviceNo, formNo, startDate, endDate, leaveType) => {
//     try {
//       const response = await leaveService.GetLeaveDetailsByUser(serviceNo);
//       if (response && response.ResultSet && Array.isArray(response.ResultSet)) {
//         const existingLeaves = response.ResultSet;

//         // Check for duplicate Form No
//         const duplicateFormNo = existingLeaves.find(leave => leave.HLF_FORM_NO === formNo);
//         if (duplicateFormNo) {
//           return { isDuplicate: true, type: 'formNo', message: `Leave Form No "${formNo}" already exists.` };
//         }

//         // Check for overlapping date range
//         const newStart = parseToComparableDate(startDate);
//         const newEnd = parseToComparableDate(endDate);
//         if (!newStart || !newEnd) return { isDuplicate: false };

//         const conflictingLeave = existingLeaves.find(leave => {
//           const leaveStatus = (leave.HLF_STATUS || '').toUpperCase().trim();
//           if (BLOCKING_STATUSES_TO_SKIP.includes(leaveStatus)) return false;
//           const existingStart = parseToComparableDate(leave.HLF_FROM_DATE);
//           const existingEnd = parseToComparableDate(leave.HLF_TO_DATE);
//           if (!existingStart || !existingEnd) return false;
//           return newStart <= existingEnd && newEnd >= existingStart;
//         });

//         if (conflictingLeave) {
//           const statusDisplay = (conflictingLeave.HLF_STATUS || 'PENDING').charAt(0).toUpperCase() +
//             (conflictingLeave.HLF_STATUS || 'PENDING').slice(1).toLowerCase();
//           return {
//             isDuplicate: true,
//             type: 'dateRange',
//             message: `You already have a ${statusDisplay} leave request (Form #${conflictingLeave.HLF_FORM_NO || ''}) for these dates.`
//           };
//         }
//       }
//       return { isDuplicate: false };
//     } catch (error) {
//       console.error('Error checking duplicate leave:', error);
//       return { isDuplicate: false };
//     }
//   };

//   // ─── Form No Validation ────────────────────────────────────────────

//   const validateFormNo = useCallback(async (formNo) => {
//     if (!formNo || !formNo.trim() || !form.p_hlf_service_no) {
//       setDuplicateError('');
//       return;
//     }
//     setIsValidatingFormNo(true);
//     try {
//       const response = await leaveService.GetLeaveDetailsByUser(form.p_hlf_service_no);
//       if (response && response.ResultSet && Array.isArray(response.ResultSet)) {
//         const duplicateFormNo = response.ResultSet.find(leave => leave.HLF_FORM_NO === formNo.trim());
//         setDuplicateError(duplicateFormNo ? `Leave Form No "${formNo}" already exists.` : '');
//       }
//     } catch (error) {
//       console.error('Error validating form no:', error);
//     } finally {
//       setIsValidatingFormNo(false);
//     }
//   }, [form.p_hlf_service_no]);

//   // ─── Effects ────────────────────────────────────────────────────────

//   // Debounced Form No validation
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (form.p_hlf_leaveform_no && form.p_hlf_service_no) {
//         validateFormNo(form.p_hlf_leaveform_no);
//       } else {
//         setDuplicateError('');
//       }
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [form.p_hlf_leaveform_no, form.p_hlf_service_no, validateFormNo]);

//   // Fetch leave types when employee is selected
//   useEffect(() => {
//     const fetchLeaveTypes = async () => {
//       const serviceNo = form.p_hlf_service_no;
//       if (!serviceNo) {
//         setLeaveTypes([]);
//         setLeaveTypeInfo('Please select an employee first');
//         return;
//       }

//       setLoadingLeaveTypes(true);
//       setLeaveTypeInfo('Loading leave types...');
//       setError('');

//       try {
//         const result = await getLeaveTypeByUser(serviceNo);
//         if (result.success && result.data) {
//           let leaveTypesArray = [];
//           if (Array.isArray(result.data)) {
//             leaveTypesArray = result.data;
//           } else if (result.data.ResultSet && Array.isArray(result.data.ResultSet)) {
//             leaveTypesArray = result.data.ResultSet;
//           } else if (result.data.resultSet && Array.isArray(result.data.resultSet)) {
//             leaveTypesArray = result.data.resultSet;
//           } else if (result.data.data && Array.isArray(result.data.data)) {
//             leaveTypesArray = result.data.data;
//           } else if (typeof result.data === 'object') {
//             for (const key of Object.keys(result.data)) {
//               if (Array.isArray(result.data[key]) && result.data[key].length > 0) {
//                 leaveTypesArray = result.data[key];
//                 break;
//               }
//             }
//           }

//           if (leaveTypesArray.length === 0) {
//             setLeaveTypes([]);
//             setLeaveTypeInfo('No leave types available for this employee');
//             return;
//           }

//           const mappedTypes = leaveTypesArray.map(item => {
//             if (typeof item === 'string' || typeof item === 'number') {
//               return { code: String(item), label: String(item), name: String(item), balance: null };
//             }
//             const code = item.HLA_LEAVE_TYPE_ID || item.leaveTypeId || item.LeaveTypeId || item.id || item.ID || '';
//             const name = item.HLT_NAME || item.label || item.name || String(code);
//             const balanceRaw = item.HLA_BALANCE_DAYS;
//             const balance = (balanceRaw !== undefined && balanceRaw !== null && balanceRaw !== '') ? Number(balanceRaw) : null;
//             const balanceText = balance !== null && !Number.isNaN(balance) ? `${fmtBalance(balance)} day${balance === 1 ? '' : 's'} left` : '';
//             return {
//               code: String(code).trim(),
//               label: balanceText ? `${name} (${balanceText})` : name,
//               name,
//               balance,
//               raw: item,
//             };
//           });

//           const validTypes = mappedTypes.filter(type => type.code);
//           if (validTypes.length > 0) {
//             setLeaveTypes(validTypes);
//             setLeaveTypeInfo(''); // Removed the count message
//             if (!form.p_hlf_leave_type) {
//               set('p_hlf_leave_type', validTypes[0].code);
//             }
//           } else {
//             setLeaveTypes([]);
//             setLeaveTypeInfo('No valid leave types found for this employee');
//           }
//         } else {
//           setLeaveTypes([]);
//           setLeaveTypeInfo(result.message || 'Failed to load leave types');
//           if (!result.success) setError(result.message);
//         }
//       } catch (error) {
//         console.error('Error fetching leave types:', error);
//         setLeaveTypes([]);
//         setLeaveTypeInfo('Error loading leave types. Please try again.');
//         setError(error.message || 'Failed to load leave types');
//       } finally {
//         setLoadingLeaveTypes(false);
//       }
//     };
//     fetchLeaveTypes();
//   }, [form.p_hlf_service_no]);

//   // Ensure end date matches start date for half day
//   useEffect(() => {
//     if (form.p_hlf_is_half_day === 'Y' && form.p_hlf_end_date !== form.p_hlf_start_date) {
//       setForm(p => ({ ...p, p_hlf_end_date: p.p_hlf_start_date }));
//     }
//   }, [form.p_hlf_start_date, form.p_hlf_is_half_day]);

//   // Validate leave days
//   useEffect(() => {
//     if (form.p_hlf_is_half_day === 'Y') {
//       setLeaveDaysError('');
//       return;
//     }
//     setLeaveDaysError(validateLeaveDays(form.p_hlf_leave_days, selectedLeaveType));
//   }, [selectedLeaveType, form.p_hlf_leave_days, form.p_hlf_is_half_day]);

//   // ─── Handlers ────────────────────────────────────────────────────────

//   const onEmpSelect = (sno, emp) => {
//     setForm(p => ({
//       ...p,
//       p_hlf_service_no: sno,
//       p_hlf_barcode_no: fmt(emp.p_barcode) || fmt(emp.p_barcode_cardno) || '',
//       p_hlf_loc_code: fmt(emp.p_location_code) || '',
//       p_hlf_dep_code: fmt(emp.p_department_code) || '',
//       p_hlf_div_code: fmt(emp.p_division_code) || '',
//       p_hlf_leave_type: '',
//     }));
//     setLeaveDaysError('');
//     setDuplicateError('');
//     setAttachment(null);
//   };

//   const toggleHalfDay = () => {
//     setForm(p => {
//       const next = p.p_hlf_is_half_day === 'Y' ? 'N' : 'Y';
//       if (next === 'Y') {
//         return {
//           ...p,
//           p_hlf_is_half_day: 'Y',
//           p_hlf_end_date: p.p_hlf_start_date,
//           p_hlf_leave_days: '0.5',
//           p_hlf_half_day_session: p.p_hlf_half_day_session || 'FIRST_HALF',
//         };
//       }
//       return { ...p, p_hlf_is_half_day: 'N', p_hlf_half_day_session: '' };
//     });
//   };

//   const onLeaveDaysChange = (value) => {
//     set('p_hlf_leave_days', value);
//     setLeaveDaysError(validateLeaveDays(value, selectedLeaveType));
//   };

//   const resetForm = () => {
//     setForm({
//       p_hlf_leaveform_no: generateFormNo(),
//       p_hlf_barcode_no: '',
//       p_hlf_service_no: '',
//       p_hlf_reason: '',
//       p_hlf_leave_type: '',
//       p_hlf_leave_days: '1',
//       p_hlf_start_date: today,
//       p_hlf_end_date: today,
//       p_hlf_div_code: '',
//       p_hlf_dep_code: '',
//       p_hlf_loc_code: '',
//       p_hlf_contact_no: '',
//       p_hlf_attachment_path: '',
//       p_acting_officer: '',
//       p_supervising_officer: '',
//       p_authorizing_officer: '',
//       p_hlf_leave_status: 'P',
//       p_hlf_approved_status: 'N',
//       p_hlf_medical_certificate: 'N',
//       p_hlf_generate_email: 'Y',
//       p_hlf_year: String(new Date().getFullYear()),
//       p_hlf_setoff_status: 'N',
//       p_hlf_mc_status: 'N',
//       p_hlf_is_half_day: 'N',
//       p_hlf_half_day_session: '',
//     });
//     setAttachment(null);
//     setLeaveTypes([]);
//     setLeaveTypeInfo('');
//     setLeaveDaysError('');
//     setDuplicateError('');
//     setSuccess('');
//     setError('');
//   };

//   const handleSuccessModalClose = () => {
//     setShowSuccessModal(false);
//     resetForm();
//     navigate('/hrm/leave/approval');
//   };

//   const handleErrorModalClose = () => {
//     setShowErrorModal(false);
//     setLoading(false);
//   };

//   // ─── Form Submission ──────────────────────────────────────────────────

//   const handleSubmit = async () => {
//     setDuplicateError('');
//     setLeaveDaysError('');

//     // Validation
//     if (!form.p_hlf_leaveform_no) { showError('Leave Form No. required'); return; }
//     if (!form.p_hlf_service_no) { showError('Employee required'); return; }
//     if (!form.p_hlf_leave_type) { showError('Leave type required'); return; }
//     if (!form.p_hlf_start_date) { showError('Start date required'); return; }
//     if (!form.p_hlf_end_date) { showError('End date required'); return; }
//     if (form.p_hlf_end_date < form.p_hlf_start_date) { showError('End date must be after start date'); return; }
//     if (form.p_hlf_is_half_day === 'Y' && !form.p_hlf_half_day_session) { showError('Select First Half or Second Half'); return; }

//     const leaveDaysValidationMsg = validateLeaveDays(form.p_hlf_leave_days, selectedLeaveType);
//     if (leaveDaysValidationMsg) {
//       setLeaveDaysError(leaveDaysValidationMsg);
//       showError(leaveDaysValidationMsg);
//       return;
//     }

//     if (!form.p_hlf_contact_no) { showError('Contact No. required'); return; }
//     const contactNo = form.p_hlf_contact_no.trim();
//     const phoneError = validatePhone(contactNo);
//     if (phoneError) { showError(phoneError); return; }

//     if (!userId) { showError('Unable to determine logged-in user. Please log in again.'); return; }

//     // Check for duplicate leave
//     try {
//       const duplicateCheck = await checkDuplicateLeave(
//         form.p_hlf_service_no,
//         form.p_hlf_leaveform_no,
//         form.p_hlf_start_date,
//         form.p_hlf_end_date,
//         form.p_hlf_leave_type
//       );
//       if (duplicateCheck.isDuplicate) {
//         if (duplicateCheck.type === 'formNo') setDuplicateError(duplicateCheck.message);
//         showError(duplicateCheck.message);
//         return;
//       }
//     } catch (error) {
//       console.error('Duplicate check failed:', error);
//     }

//     let attachmentPath = '';
//     if (attachment) {
//       attachmentPath = attachment.data || '';
//     }

//     setLoading(true);
//     setError('');
//     setSuccess('');
//     setShowSuccessModal(false);
//     setShowErrorModal(false);

//     try {
//       const result = await dispatch(
//         RequestLeave(
//           form.p_hlf_service_no,
//           form.p_hlf_leaveform_no,
//           form.p_hlf_leave_type,
//           toBackendDate(form.p_hlf_start_date),
//           toBackendDate(form.p_hlf_end_date),
//           form.p_hlf_is_half_day,
//           form.p_hlf_is_half_day === 'Y' ? form.p_hlf_half_day_session : '',
//           form.p_hlf_reason,
//           contactNo,
//           attachmentPath,
//           userId
//         )
//       );

//       let isSuccess = false;
//       let responseMessage = '';

//       if (typeof result === 'string') {
//         responseMessage = result;
//         isSuccess = result.toLowerCase().includes('success') || result.toLowerCase().includes('successfully');
//       } else if (result && typeof result === 'object') {
//         if (result.StatusCode === 200) {
//           isSuccess = true;
//           responseMessage = result.Result || 'Leave request submitted successfully!';
//         } else if (result.StatusCode) {
//           isSuccess = false;
//           responseMessage = result.Result || result.message || `Failed with status ${result.StatusCode}`;
//         } else if (result.success === true) {
//           isSuccess = true;
//           responseMessage = result.message || 'Leave request submitted successfully!';
//         } else if (result.success === false) {
//           isSuccess = false;
//           responseMessage = result.message || 'Failed to submit leave request';
//         } else if (result.message) {
//           responseMessage = result.message;
//           isSuccess = result.message.toLowerCase().includes('success') || result.message.toLowerCase().includes('successfully');
//         } else {
//           isSuccess = true;
//           responseMessage = 'Leave request submitted successfully!';
//         }
//       } else if (result) {
//         isSuccess = true;
//         responseMessage = 'Leave request submitted successfully!';
//       } else {
//         isSuccess = true;
//         responseMessage = 'Leave request submitted successfully!';
//       }

//       setLoading(false);

//       if (isSuccess) {
//         setModalMessage(responseMessage);
//         setShowSuccessModal(true);
//       } else {
//         setModalMessage(responseMessage || 'Failed to submit leave request');
//         setShowErrorModal(true);
//       }

//     } catch (e) {
//       console.error('Error submitting leave request:', e);
//       setLoading(false);

//       let errorMsg = typeof e === 'string' ? e : (e?.message || 'Failed to add leave');

//       if (errorMsg.toLowerCase().includes('duplicate') ||
//         errorMsg.toLowerCase().includes('already exists') ||
//         errorMsg.toLowerCase().includes('existing')) {
//         errorMsg = 'A leave request with this Form No or date range already exists.';
//       }

//       if (errorMsg.toLowerCase().includes('success') || errorMsg.toLowerCase().includes('successfully')) {
//         setModalMessage(errorMsg);
//         setShowSuccessModal(true);
//       } else {
//         setModalMessage(errorMsg);
//         setShowErrorModal(true);
//       }
//     }
//   };

//   // ─── Render ──────────────────────────────────────────────────────────

//   return (
//     <div className="flex flex-col h-full overflow-hidden">
//       <SuccessModal isOpen={showSuccessModal} message={modalMessage} onClose={handleSuccessModalClose} />
//       <ErrorModal isOpen={showErrorModal} message={modalMessage} onClose={handleErrorModalClose} />

//       {loading && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//           <div className="bg-white rounded-2xl shadow-2xl p-8 flex flex-col items-center">
//             <Loader2 size={48} className="text-primary-500 animate-spin mb-4" />
//             <p className="text-gray-700 font-medium">Submitting leave request...</p>
//             <p className="text-gray-400 text-sm mt-1">Please wait</p>
//           </div>
//         </div>
//       )}

//       <div className="flex-1 overflow-hidden p-4 flex flex-col">
//         <div className="w-full h-full flex flex-col justify-between">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-8 flex-1">

//             {/* ─── LEFT COLUMN ──────────────────────────────────────── */}
//             <div className="space-y-8">

//               {/* Leave Identification */}
//               <div>
//                 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3 flex items-center gap-1.5">
//                   <Hash size={10} /> Leave Identification
//                 </p>
//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className={LBL}>Leave Form No. *</label>
//                     <div className="relative">
//                       <input
//                         className={`${INP} ${duplicateError ? 'border-red-300 focus:ring-red-200 focus:border-red-400' : ''} ${isValidatingFormNo ? 'pr-8' : ''}`}
//                         placeholder="Enter Leave Form No"
//                         value={form.p_hlf_leaveform_no}
//                         onChange={e => set('p_hlf_leaveform_no', e.target.value)}
//                       />
//                       {/* Regenerate Button - Add this right after the input */}
//                       <button
//                         type="button"
//                         onClick={() => set('p_hlf_leaveform_no', generateFormNo())}
//                         className="absolute right-10 top-1/2 -translate-y-1/2 text-gray-400 hover:text-primary-600 transition-colors"
//                         title="Regenerate Form Number"
//                       >
//                         <RefreshCw size={16} className="hover:rotate-180 transition-transform duration-300" />
//                       </button>
//                       {isValidatingFormNo && (
//                         <div className="absolute right-3 top-1/2 -translate-y-1/2">
//                           <Loader2 size={16} className="animate-spin text-primary-500" />
//                         </div>
//                       )}
//                       {!isValidatingFormNo && form.p_hlf_leaveform_no && !duplicateError && form.p_hlf_service_no && (
//                         <div className="absolute right-3 top-1/2 -translate-y-1/2">
//                           <CheckCircle size={16} className="text-emerald-500" />
//                         </div>
//                       )}
//                     </div>
//                     {duplicateError ? (
//                       <p className="mt-1 text-[11px] text-red-600 flex items-center gap-1">
//                         <AlertCircle size={11} className="shrink-0" />
//                         {duplicateError}
//                       </p>
//                     ) : (
//                       !isValidatingFormNo && form.p_hlf_leaveform_no && form.p_hlf_service_no && (
//                         <p className="mt-1 text-[11px] text-emerald-600 flex items-center gap-1">
//                           <CheckCircle size={11} className="shrink-0" />
//                           Form No is available
//                         </p>
//                       )
//                     )}
//                   </div>
//                   <div>
//                     <label className={LBL}>Leave Year</label>
//                     <div className="relative">
//                       <select
//                         className={`${SEL} pr-9`}
//                         value={form.p_hlf_year}
//                         onChange={e => set('p_hlf_year', e.target.value)}
//                       >
//                         {getYearOptions().map(year => (
//                           <option key={year} value={String(year)}>{year}</option>
//                         ))}
//                       </select>
//                       <ChevronDown
//                         size={15}
//                         className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Employee Section */}
//               <div>
//                 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3 flex items-center gap-1.5">
//                   <User size={10} /> Employee
//                 </p>
//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className={LBL}>Select Employee *</label>
//                     <EmpSearch
//                       value={form.p_hlf_service_no}
//                       onChange={onEmpSelect}
//                       employees={employeeOptions}
//                     />
//                   </div>
//                   <div>
//                     <label className={LBL}>Service No.</label>
//                     <input className={`${INP} bg-gray-100 cursor-not-allowed`} readOnly
//                       value={form.p_hlf_service_no} placeholder="Auto-filled on selection" />
//                   </div>
//                 </div>
//                 <div className="grid grid-cols-2 gap-4 mt-3">
//                   <div>
//                     <label className={LBL}>Barcode No.</label>
//                     <input className={INP} placeholder="Auto-filled or enter manually"
//                       value={form.p_hlf_barcode_no} onChange={e => set('p_hlf_barcode_no', e.target.value)} />
//                   </div>
//                   <div>
//                     <label className={LBL}>Contact No. *</label>
//                     <div className={`${INP} flex items-center gap-2`}>
//                       <Phone size={13} className="text-gray-400 shrink-0" />
//                       <input
//                         type="tel"
//                         inputMode="numeric"
//                         maxLength={10}
//                         className="flex-1 bg-transparent outline-none text-sm"
//                         placeholder="e.g. 0771234567"
//                         value={form.p_hlf_contact_no}
//                         onChange={e => {
//                           const value = e.target.value.replace(/\D/g, '');
//                           set('p_hlf_contact_no', value);
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* ─── RIGHT COLUMN ─────────────────────────────────────── */}
//             <div className="space-y-8">

//               {/* Leave Details */}
//               <div>
//                 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3 flex items-center gap-1.5">
//                   <Calendar size={10} /> Leave Details
//                 </p>

//                 <div className="mb-3">
//                   <div className="grid grid-cols-2 gap-4">
//                     <div>
//                       <label className={LBL}>Leave Type *</label>
//                       <select
//                         className={`${SEL} ${!form.p_hlf_service_no ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''}`}
//                         value={form.p_hlf_leave_type}
//                         onChange={e => set('p_hlf_leave_type', e.target.value)}
//                         disabled={!form.p_hlf_service_no || loadingLeaveTypes}
//                       >
//                         <option value="">Select Leave Type</option>
//                         {leaveTypes.map((type, index) => (
//                           <option
//                             key={`${type.code}-${index}`}
//                             value={type.code}
//                             disabled={type.balance !== null && type.balance <= 0}
//                           >
//                             {type.label}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div>
//                       <label className={LBL}>Leave Days *</label>
//                       <input
//                         type="number"
//                         step="0.5"
//                         min="0.5"
//                         max={selectedLeaveType && selectedLeaveType.balance !== null ? selectedLeaveType.balance : undefined}
//                         className={`${INP} ${form.p_hlf_is_half_day === 'Y' ? 'bg-gray-100 cursor-not-allowed' : ''} ${leaveDaysError ? 'border-red-300 focus:ring-red-200 focus:border-red-400' : ''}`}
//                         readOnly={form.p_hlf_is_half_day === 'Y'}
//                         value={form.p_hlf_leave_days}
//                         onChange={e => onLeaveDaysChange(e.target.value)}
//                       />
//                       {leaveDaysError && form.p_hlf_is_half_day !== 'Y' && (
//                         <p className="mt-1 text-[11px] text-red-600 flex items-center gap-1">
//                           <AlertCircle size={11} className="shrink-0" />
//                           {leaveDaysError}
//                         </p>
//                       )}
//                     </div>
//                   </div>

//                   {/* Leave Type Balance Info */}
//                   {form.p_hlf_leave_type && (() => {
//                     const selectedType = selectedLeaveType;
//                     if (!selectedType || selectedType.balance === null) return null;
//                     const low = selectedType.balance <= 0;
//                     return (
//                       <div className={`mt-2 flex items-center gap-2 px-3 py-2 rounded-lg text-[11px] ${low ? 'bg-red-50 border border-red-200 text-red-700' : 'bg-emerald-50 border border-emerald-200 text-emerald-700'
//                         }`}>
//                         <BadgeCheck size={13} className="shrink-0" />
//                         <span>
//                           {selectedType.name}: {fmtBalance(selectedType.balance)} day{selectedType.balance === 1 ? '' : 's'} remaining
//                           {low ? ' — no balance left' : ''}
//                         </span>
//                       </div>
//                     );
//                   })()}

//                   {/* Leave Type Info */}
//                   {leaveTypeInfo && (
//                     <div className={`mt-2 flex items-center gap-2 px-3 py-2 rounded-lg text-[11px] ${!form.p_hlf_service_no
//                       ? 'bg-emerald-50 border border-emerald-200 text-emerald-700'
//                       : 'bg-gray-50 border border-gray-200 text-gray-600'
//                       }`}>
//                       <Info size={13} className="shrink-0" />
//                       <span>{leaveTypeInfo}</span>
//                       {loadingLeaveTypes && <Loader2 size={13} className="animate-spin ml-auto" />}
//                     </div>
//                   )}
//                 </div>

//                 {/* Date Fields - Increased width */}
//                 <div className="grid grid-cols-2 gap-6 mb-3">
//                   <DatePickerWithFormat
//                     label="Start Date"
//                     value={form.p_hlf_start_date}
//                     onChange={(date) => set('p_hlf_start_date', date)}
//                     required={true}
//                     placeholder="2026/09/03"
//                   />
//                   <DatePickerWithFormat
//                     label="End Date"
//                     value={form.p_hlf_end_date}
//                     onChange={(date) => set('p_hlf_end_date', date)}
//                     required={true}
//                     disabled={form.p_hlf_is_half_day === 'Y'}
//                     placeholder="2026/09/03"
//                   />
//                 </div>

//                 {/* Half Day Toggle */}
//                 <div className="mb-3 p-3 bg-gray-50 border border-gray-200 rounded-lg">
//                   <label className="flex items-center gap-2.5 cursor-pointer select-none">
//                     <button
//                       type="button"
//                       onClick={toggleHalfDay}
//                       className={`relative w-11 h-6 rounded-full transition-colors shrink-0 flex items-center ${form.p_hlf_is_half_day === 'Y' ? 'bg-primary-500' : 'bg-gray-200'
//                         }`}
//                     >
//                       <span className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow transition-transform ${form.p_hlf_is_half_day === 'Y' ? 'translate-x-6' : 'translate-x-1'
//                         }`} />
//                     </button>
//                     <Sun size={12} className="text-gray-500 shrink-0" />
//                     <span className="text-[12px] text-gray-700 font-medium">Is Half Day</span>
//                   </label>

//                   {form.p_hlf_is_half_day === 'Y' && (
//                     <div className="mt-3 flex gap-4">
//                       {[
//                         ['FIRST_HALF', 'First Half'],
//                         ['SECOND_HALF', 'Second Half'],
//                       ].map(([val, label]) => (
//                         <label key={val} className="flex items-center gap-1.5 text-[12px] text-gray-700 cursor-pointer">
//                           <input
//                             type="radio"
//                             name="half_day_session"
//                             className="accent-primary-500 w-3.5 h-3.5"
//                             checked={form.p_hlf_half_day_session === val}
//                             onChange={() => set('p_hlf_half_day_session', val)}
//                           />
//                           {label}
//                         </label>
//                       ))}
//                     </div>
//                   )}
//                 </div>

//                 {/* Reason */}
//                 <div className="flex-1 flex flex-col">
//                   <label className={LBL}>Reason</label>
//                   <textarea
//                     className={`${INP} flex-1 min-h-[120px] resize-none`}
//                     placeholder="Reason for leave..."
//                     value={form.p_hlf_reason}
//                     onChange={e => set('p_hlf_reason', e.target.value)}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* ─── ACTION BUTTONS ──────────────────────────────────────── */}
//           <div className="flex gap-3 pt-4">
//             <button
//               onClick={() => navigate('/hrm/leave')}
//               className="px-6 py-2.5 text-sm font-medium text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-100 transition-colors"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleSubmit}
//               disabled={loading || !!duplicateError || isValidatingFormNo}
//               className="px-8 py-2.5 text-sm font-bold text-white bg-primary-500 hover:bg-primary-600 rounded-xl transition-colors disabled:opacity-60 flex items-center gap-2"
//             >
//               Submit Leave Request
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { submitLeaveRequest } from '../../store/slices/leaveSlice';
import { fetchLeaveTypesByUser } from '../../store/slices/leaveTypesSlice';
import { fetchAllHolidays } from '../../store/slices/holidaySlice';
import {
  Plus, Search, ChevronDown, X, User, Calendar,
  Hash, BadgeCheck, Stethoscope, Mail, Layers,
  AlertCircle, Loader2, ArrowLeft, CheckCircle, Sun, Phone, Info, Upload, File, Trash2, RefreshCw
} from 'lucide-react';
import leaveService from '../../services/LeaveService';
import {
  fetchLeaveTypes,
} from '../../store/slices/leaveTypesSlice';



/**
 * Convert ISO date (YYYY-MM-DD) to (YYYY/MM/DD)
 */
const toBackendDate = (isoDate) => {
  if (!isoDate) return '';
  const [y, m, d] = isoDate.split('-');
  if (!y || !m || !d) return isoDate;
  return `${y}/${m}/${d}`;
};

/**
 * Format date for display (YYYY/MM/DD)
 */
const formatDateForDisplay = (dateStr) => {
  if (!dateStr) return '';
  if (dateStr.includes('/')) return dateStr;
  const parts = dateStr.split('-');
  if (parts.length === 3) {
    return `${parts[0]}/${parts[1]}/${parts[2]}`;
  }
  return dateStr;
};

/**
* Generate random 8-digit form number
*/
const generateFormNo = () => {
  const min = 10000000;
  const max = 99999999;
  return String(Math.floor(Math.random() * (max - min + 1)) + min);
};

/**
 * Format string value - remove null/undefined/empty
 */
const fmt = (v) => (!v || v === 'null') ? '' : String(v).trim();

/**
 * Format balance numbers - remove unnecessary decimals
 */
const fmtBalance = (n) => {
  if (n === null || n === undefined || Number.isNaN(n)) return '';
  return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.?0+$/, '');
};

/**
 * Get year options for dropdown
 */
const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear; year >= 2020; year--) {
    years.push(year);
  }
  return years;
};

/**
 * Validate phone number - must be 10 digits
 */
const validatePhone = (value) => {
  if (!value) return '';  // empty = valid (optional)
  if (!/^\d+$/.test(value)) {
    return 'Contact No. must contain only numbers';
  }
  if (value.length !== 10) {
    return 'Contact No. must contain exactly 10 numbers';
  }
  return '';
};

/**
 * Validate leave days against available balance
 */
const validateLeaveDays = (daysValue, leaveType) => {
  if (daysValue === '' || daysValue === null || daysValue === undefined) {
    return 'Leave Days is required';
  }

  const numValue = Number(daysValue);

  if (Number.isNaN(numValue)) {
    return 'Leave Days must be a number';
  }

  if (numValue <= 0) {
    return 'Leave Days must be greater than 0';
  }

  if (leaveType && leaveType.balance !== null && !Number.isNaN(leaveType.balance)) {
    if (numValue > leaveType.balance) {
      return `Only ${fmtBalance(leaveType.balance)} day${leaveType.balance === 1 ? '' : 's'} available for ${leaveType.name}`;
    }
  }

  return '';
};

// ─── HOLIDAY / WEEKEND HELPERS ──────────────────────────────────────


/**
 * Company weekend = Sunday only (Saturday is a working day).
 */
const isWeekend = (dateStr) => {
  const normalized = normalizeDate(dateStr);
  if (!normalized) return false;
  const [y, m, d] = normalized.split('-').map(Number);
  const day = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  return day === 0; // 0 = Sunday
};

/**
 * Normalize a date string to YYYY-MM-DD for comparison
 */
const normalizeDate = (dateStr) => {
  if (!dateStr) return '';

  const cleaned = String(dateStr).trim();

  // 8-digit compact form: YYYYMMDD
  if (/^\d{8}$/.test(cleaned)) {
    return `${cleaned.slice(0, 4)}-${cleaned.slice(4, 6)}-${cleaned.slice(6, 8)}`;
  }

  // ISO form: YYYY-MM-DD (optionally with time)
  const isoMatch = cleaned.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
  }

  // US form: M/D/YYYY (optionally with time suffix)
  const usMatch = cleaned.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (usMatch) {
    const [, m, d, y] = usMatch;
    const mm = String(m).padStart(2, '0');
    const dd = String(d).padStart(2, '0');
    return `${y}-${mm}-${dd}`;
  }

  return '';
};

/**
 * Build a Set of holiday date strings from the holidays array
 */
const buildHolidaySet = (holidays) => {
  const set = new Set();
  (holidays || []).forEach(h => {
    const raw = h.HAH_HOLIDAY_DATE || h.holidayDate || h.HAH_DATE;
    const normalized = normalizeDate(raw);
    if (normalized) set.add(normalized);
  });
  return set;
};

/**
 * Check if a single date is a holiday
 */
const isHoliday = (dateStr, holidaySet) => {
  const normalized = normalizeDate(dateStr);
  return holidaySet.has(normalized);
};

/**
 * Generate all dates between start and end (inclusive)
 */
const getDateRange = (startStr, endStr) => {
  const dates = [];
  const start = new Date(startStr);
  const end = new Date(endStr);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return dates;

  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    dates.push(new Date(d).toISOString().split('T')[0]);
  }
  return dates;
};

/**
 * Validate a date range against Sundays and holidays.
 */
const validateDateRange = (startStr, endStr, holidaySet) => {
  if (!startStr || !endStr) {
    return { valid: true, message: '', blockedDates: [] };
  }

  const dates = getDateRange(startStr, endStr);
  if (dates.length === 0) {
    return { valid: true, message: '', blockedDates: [] };
  }

  const sundayDates = [];
  const holidayDates = [];

  dates.forEach(date => {
    if (isWeekend(date)) {
      sundayDates.push(date);
    } else if (isHoliday(date, holidaySet)) {
      holidayDates.push(date);
    }
  });

  const blockedDates = [
    ...sundayDates.map(d => ({ date: d, reason: 'sunday' })),
    ...holidayDates.map(d => ({ date: d, reason: 'holiday' })),
  ];

  if (blockedDates.length === 0) {
    return { valid: true, message: '', blockedDates: [] };
  }

  const parts = [];
  if (sundayDates.length > 0) {
    parts.push(`${sundayDates.length} Sunday${sundayDates.length > 1 ? 's' : ''}`);
  }
  if (holidayDates.length > 0) {
    parts.push(`${holidayDates.length} holiday${holidayDates.length > 1 ? 's' : ''}`);
  }

  return {
    valid: false,
    message: `Selected range includes ${parts.join(' and ')}: ${blockedDates
      .map(d => formatDateForDisplay(d.date))
      .join(', ')}`,
    blockedDates,
  };
};

// ─── CSS CLASSES ──────────────────────────────────────────────────────

const INP = "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 bg-gray-50 focus:bg-white transition-colors";
const SEL = INP + " appearance-none";
const LBL = "block text-[11px] font-semibold text-gray-600 mb-1 uppercase tracking-wide";

// ─── COMPONENTS ──────────────────────────────────────────────────────

/**
 * Employee Search Dropdown Component
 */
function EmpSearch({ value, onChange, employees, placeholder = 'Search employee...' }) {
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const filtered = useMemo(() => {
    if (!q) return employees;
    const lq = q.toLowerCase();
    return employees.filter(e =>
      fmt(e.p_ced_service_no).toLowerCase().includes(lq) ||
      `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.toLowerCase().includes(lq) ||
      fmt(e.p_report_name).toLowerCase().includes(lq)
    );
  }, [employees, q]);

  const selected = employees.find(e => fmt(e.p_ced_service_no) === value);
  const displayName = selected
    ? `${fmt(selected.p_ced_service_no)} — ${fmt(selected.p_report_name) || `${fmt(selected.p_first_name)} ${fmt(selected.p_last_name)}`}`
    : '';

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      <div className={`${INP} flex items-center gap-2 cursor-pointer`} onClick={() => setOpen(v => !v)}>
        <User size={13} className="text-gray-400 shrink-0" />
        <span className={`flex-1 text-sm truncate ${value ? 'text-gray-800' : 'text-gray-400'}`}>
          {value ? displayName : placeholder}
        </span>
        <ChevronDown size={12} className={`text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </div>
      {open && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-xl shadow-xl z-50">
          <div className="p-2 border-b border-gray-100">
            <div className="relative">
              <Search size={12} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                autoFocus
                value={q}
                onChange={e => setQ(e.target.value)}
                placeholder="Name or service no..."
                className="w-full pl-7 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary-300"
              />
            </div>
          </div>
          <div className="max-h-52 overflow-y-auto py-1">
            {filtered.length === 0
              ? <p className="text-center text-[12px] text-gray-400 py-3">No results</p>
              : filtered.map(e => {
                const sno = fmt(e.p_ced_service_no);
                const name = fmt(e.p_report_name) || `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.trim();
                return (
                  <button
                    key={sno}
                    onClick={() => { onChange(sno, e); setOpen(false); setQ(''); }}
                    className={`w-full flex items-center gap-2.5 px-3 py-2 hover:bg-primary-50 transition-colors text-left ${value === sno ? 'bg-primary-50 text-primary-700' : ''}`}
                  >
                    <span className="text-[11px] font-mono text-gray-400 w-16 shrink-0">{sno}</span>
                    <span className="text-[12px] text-gray-800 truncate">{name}</span>
                  </button>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
}

/**
 * Date Picker with YYYY/MM/DD Format
 */
function DatePickerWithFormat({ value, onChange, label, required = false, disabled = false, placeholder = 'YYYY/MM/DD' }) {
  const dateInputRef = useRef(null);
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    setDisplayValue(formatDateForDisplay(value));
  }, [value]);

  const handleTextChange = (e) => {
    let input = e.target.value.replace(/\//g, '');
    let formatted = '';

    if (input.length > 0) {
      if (input.length <= 4) {
        formatted = input;
      } else if (input.length <= 6) {
        formatted = `${input.slice(0, 4)}/${input.slice(4)}`;
      } else {
        formatted = `${input.slice(0, 4)}/${input.slice(4, 6)}/${input.slice(6, 8)}`;
      }
    }

    setDisplayValue(formatted);

    const parts = formatted.split('/');
    if (parts.length === 3 && parts[0].length === 4 && parts[1].length === 2 && parts[2].length === 2) {
      onChange(`${parts[0]}-${parts[1]}-${parts[2]}`);
    }
  };

  const openCalendar = () => {
    if (!disabled && dateInputRef.current) {
      dateInputRef.current.showPicker?.();
    }
  };

  const handleDatePickerChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div>
      <label className={LBL}>
        {label} {required && '*'}
      </label>
      <div className="relative">
        <input
          ref={dateInputRef}
          type="date"
          className="absolute opacity-0 w-0 h-0 pointer-events-none"
          value={value || ''}
          onChange={handleDatePickerChange}
          disabled={disabled}
        />
        <div className="relative">
          <input
            type="text"
            className={`${INP} pr-10 ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'cursor-pointer'}`}
            value={displayValue}
            onChange={handleTextChange}
            onClick={openCalendar}
            placeholder={placeholder}
            disabled={disabled}
            maxLength={10}
            readOnly={disabled}
          />
          <button
            type="button"
            onClick={openCalendar}
            className={`absolute right-3 top-1/2 -translate-y-1/2 transition-colors ${disabled ? 'text-gray-300 cursor-not-allowed' : 'text-gray-400 hover:text-gray-600'
              }`}
            disabled={disabled}
          >
            <Calendar size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}

/**
 * File Upload Component with Drag & Drop
 */
function FileUpload({ value, onChange, onRemove, accept = '.pdf,.doc,.docx,.jpg,.jpeg,.png', maxSize = 5 }) {
  const [dragOver, setDragOver] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const fileInputRef = useRef(null);

  const handleFileSelect = (file) => {
    setUploadError('');

    if (file.size > maxSize * 1024 * 1024) {
      setUploadError(`File size exceeds ${maxSize}MB limit.`);
      return;
    }

    const fileType = file.type;
    const validTypes = accept.split(',').map(t => t.trim());
    const isValidType = validTypes.some(type => {
      if (type.startsWith('.')) {
        return file.name.toLowerCase().endsWith(type.toLowerCase());
      }
      return fileType.includes(type.replace('*', ''));
    });

    if (!isValidType) {
      setUploadError(`Invalid file type. Accepted: ${accept}`);
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      onChange({
        file: file,
        name: file.name,
        size: file.size,
        type: file.type,
        data: e.target.result,
        lastModified: file.lastModified
      });
    };
    reader.onerror = () => {
      setUploadError('Failed to read file.');
    };
    reader.readAsDataURL(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) {
      handleFileSelect(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };


  return (
    <div className="space-y-2">
      {!value ? (
        <div
          onClick={handleClick}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          className={`border-2 border-dashed rounded-lg p-4 text-center cursor-pointer transition-colors
            ${dragOver ? 'border-primary-400 bg-primary-50' : 'border-gray-300 hover:border-primary-400 hover:bg-gray-50'}`}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept={accept}
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                handleFileSelect(e.target.files[0]);
              }
              e.target.value = '';
            }}
            className="hidden"
          />
          <Upload size={24} className="mx-auto text-gray-400 mb-2" />
          <p className="text-sm text-gray-600">Click or drag to upload attachment</p>
          <p className="text-xs text-gray-400 mt-1">Accepted: {accept} (max {maxSize}MB)</p>
          {uploadError && (
            <p className="text-xs text-red-600 mt-2">{uploadError}</p>
          )}
        </div>
      ) : (
        <div className="flex items-center gap-3 p-3 bg-gray-50 border border-gray-200 rounded-lg">
          <File size={20} className="text-primary-500 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-800 truncate">{value.name}</p>
            <p className="text-xs text-gray-500">{formatFileSize(value.size)}</p>
          </div>
          <button
            onClick={onRemove}
            className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            title="Remove file"
          >
            <Trash2 size={16} />
          </button>
        </div>
      )}
    </div>
  );
}

/**
 * Success Modal
 */
function SuccessModal({ isOpen, message, onClose }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6 transform transition-all">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircle size={32} className="text-emerald-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Success!</h3>
          <p className="text-gray-600 text-sm mb-6">{message || 'Leave request submitted successfully!'}</p>
          <button
            onClick={onClose}
            className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}

/**
 * Error Modal
 */
function ErrorModal({ isOpen, message, onClose }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6 transform transition-all">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <AlertCircle size={32} className="text-red-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Error</h3>
          <p className="text-gray-600 text-sm mb-6">{message || 'Failed to submit leave request'}</p>
          <button
            onClick={onClose}
            className="px-6 py-2.5 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}



// ─── MAIN COMPONENT ────────────────────────────────────────────────────

/**
 * Leave Request Form
 * Allows employees to submit leave requests with validation and duplicate checking
 */
export default function LeaveAdd() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { employees } = useSelector(s => s.employees);
  const authUser = useSelector(s => s.auth.user);
  const userId = authUser?.raw?.ADU_EmployeeId || authUser?.serviceNo || '';
  const { holidays } = useSelector(s => s.holiday);
  const masterLeaveTypes = useSelector((state) => state.leaveTypes.types);

  const employeeOptions = useMemo(() => {
    return (employees || []).map(emp => ({
      ...emp,
      p_ced_service_no: emp.p_ced_service_no || emp.HED_SERVICE_NO || emp.HED_CED_SERVICE_NO || '',
      p_first_name: emp.p_first_name || emp.HED_FIRST_NAME || '',
      p_last_name: emp.p_last_name || emp.HED_LAST_NAME || '',
      p_report_name: emp.p_report_name || emp.HED_REPORT_NAME || '',
      p_barcode: emp.p_barcode || emp.HED_SERVICE_NO || '',
      p_location_code: emp.p_location_code || emp.HED_LOCATION_ID || '',
      p_department_code: emp.p_department_code || emp.HDD_DEPARTMENT_CODE || '',
      p_division_code: emp.p_division_code || emp.HED_GROUP || '',
    }));
  }, [employees]);

  const today = new Date().toISOString().split('T')[0];

  // ── 4. ALL useState declarations ──────────────────────────────────
  const [form, setForm] = useState({
    p_hlf_leaveform_no: generateFormNo(),
    p_hlf_barcode_no: '',
    p_hlf_service_no: '',
    p_hlf_reason: '',
    p_hlf_leave_type: '',
    p_hlf_leave_days: '1',
    p_hlf_start_date: today,
    p_hlf_end_date: today,
    p_hlf_div_code: '',
    p_hlf_dep_code: '',
    p_hlf_loc_code: '',
    p_hlf_contact_no: '',
    p_hlf_attachment_path: '',
    p_acting_officer: '',
    p_supervising_officer: '',
    p_authorizing_officer: '',
    p_hlf_leave_status: 'P',
    p_hlf_approved_status: 'N',
    p_hlf_medical_certificate: 'N',
    p_hlf_generate_email: 'Y',
    p_hlf_year: String(new Date().getFullYear()),
    p_hlf_setoff_status: 'N',
    p_hlf_mc_status: 'N',
    p_hlf_is_half_day: 'N',
    p_hlf_half_day_session: '',
  });

  const [attachment, setAttachment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loadingLeaveTypes, setLoadingLeaveTypes] = useState(false);
  const [leaveTypeInfo, setLeaveTypeInfo] = useState('');
  const [leaveDaysError, setLeaveDaysError] = useState('');
  const [duplicateError, setDuplicateError] = useState('');
  const [isValidatingFormNo, setIsValidatingFormNo] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [dateRangeError, setDateRangeError] = useState('');

  // ── 5. Derived values / helpers ─────────────────
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const showError = (msg) => {
    setError(msg);
    setModalMessage(msg);
    setShowErrorModal(true);
  };

  const selectedLeaveType = useMemo(
    () => leaveTypes.find(t => t.code === form.p_hlf_leave_type) || null,
    [leaveTypes, form.p_hlf_leave_type]
  );

  const holidaySet = useMemo(() => buildHolidaySet(holidays), [holidays]);

  // ── 6. Duplicate check helpers ────────────────────────────────────
  const BLOCKING_STATUSES_TO_SKIP = ['CANCELLED', 'REJECTED', 'DECLINED'];

  const parseToComparableDate = (dateStr) => {
    if (!dateStr) return null;
    const cleaned = String(dateStr).trim();
    if (/^\d{8}$/.test(cleaned)) {
      return new Date(`${cleaned.slice(0, 4)}-${cleaned.slice(4, 6)}-${cleaned.slice(6, 8)}`);
    }
    const parsed = new Date(cleaned);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  };

  const checkDuplicateLeave = async (serviceNo, formNo, startDate, endDate, leaveType) => {
    try {
      const response = await leaveService.GetLeaveDetailsByUser(serviceNo);
      if (response && response.ResultSet && Array.isArray(response.ResultSet)) {
        const existingLeaves = response.ResultSet;

        // Check for duplicate Form No
        const duplicateFormNo = existingLeaves.find(leave => leave.HLF_FORM_NO === formNo);
        if (duplicateFormNo) {
          return { isDuplicate: true, type: 'formNo', message: `Leave Form No "${formNo}" already exists.` };
        }

        // Check for overlapping date range
        const newStart = parseToComparableDate(startDate);
        const newEnd = parseToComparableDate(endDate);
        if (!newStart || !newEnd) return { isDuplicate: false };

        const conflictingLeave = existingLeaves.find(leave => {
          const leaveStatus = (leave.HLF_STATUS || '').toUpperCase().trim();
          if (BLOCKING_STATUSES_TO_SKIP.includes(leaveStatus)) return false;
          const existingStart = parseToComparableDate(leave.HLF_FROM_DATE);
          const existingEnd = parseToComparableDate(leave.HLF_TO_DATE);
          if (!existingStart || !existingEnd) return false;
          return newStart <= existingEnd && newEnd >= existingStart;
        });

        if (conflictingLeave) {
          const statusDisplay = (conflictingLeave.HLF_STATUS || 'PENDING').charAt(0).toUpperCase() +
            (conflictingLeave.HLF_STATUS || 'PENDING').slice(1).toLowerCase();
          return {
            isDuplicate: true,
            type: 'dateRange',
            message: `You already have a ${statusDisplay} leave request (Form #${conflictingLeave.HLF_FORM_NO || ''}) for these dates.`
          };
        }
      }
      return { isDuplicate: false };
    } catch (error) {
      console.error('Error checking duplicate leave:', error);
      return { isDuplicate: false };
    }
  };

  // ── 7. Form No validation (useCallback) ───────────────────────────
  const validateFormNo = useCallback(async (formNo) => {
    if (!formNo || !formNo.trim() || !form.p_hlf_service_no) {
      setDuplicateError('');
      return;
    }
    setIsValidatingFormNo(true);
    try {
      const response = await leaveService.GetLeaveDetailsByUser(form.p_hlf_service_no);
      if (response && response.ResultSet && Array.isArray(response.ResultSet)) {
        const duplicateFormNo = response.ResultSet.find(leave => leave.HLF_FORM_NO === formNo.trim());
        setDuplicateError(duplicateFormNo ? `Leave Form No "${formNo}" already exists.` : '');
      }
    } catch (error) {
      console.error('Error validating form no:', error);
    } finally {
      setIsValidatingFormNo(false);
    }
  }, [form.p_hlf_service_no]);

  // ── 8. Effects ────────────────────────────────────────────────────

  // Fetch holidays on mount
  useEffect(() => {
    dispatch(fetchAllHolidays());
    dispatch(fetchLeaveTypes());
  }, [dispatch]);

  // Validate date range against weekends + holidays
  useEffect(() => {
    if (!form.p_hlf_start_date || !form.p_hlf_end_date) {
      setDateRangeError('');
      return;
    }

    if (form.p_hlf_is_half_day === 'Y') {
      // Half day: only check the single date
      const result = validateDateRange(
        form.p_hlf_start_date,
        form.p_hlf_start_date,
        holidaySet
      );
      setDateRangeError(result.valid ? '' : result.message);
      return;
    }

    const result = validateDateRange(
      form.p_hlf_start_date,
      form.p_hlf_end_date,
      holidaySet
    );
    setDateRangeError(result.valid ? '' : result.message);
  }, [
    form.p_hlf_start_date,
    form.p_hlf_end_date,
    form.p_hlf_is_half_day,
    holidaySet,
  ]);

  // Debounced Form No validation
  useEffect(() => {
    const timer = setTimeout(() => {
      if (form.p_hlf_leaveform_no && form.p_hlf_service_no) {
        validateFormNo(form.p_hlf_leaveform_no);
      } else {
        setDuplicateError('');
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [form.p_hlf_leaveform_no, form.p_hlf_service_no, validateFormNo]);

  // Fetch leave types when employee is selected
  useEffect(() => {
    const fetchLeaveTypes = async () => {
      const serviceNo = form.p_hlf_service_no;
      if (!serviceNo) {
        setLeaveTypes([]);
        setLeaveTypeInfo('Please select an employee first');
        return;
      }

      setLoadingLeaveTypes(true);
      setLeaveTypeInfo('Loading leave types...');
      setError('');

      try {
        const result = await dispatch(fetchLeaveTypesByUser(serviceNo)).unwrap();
        if (result.success && result.data) {
          let leaveTypesArray = [];
          if (Array.isArray(result.data)) {
            leaveTypesArray = result.data;
          } else if (result.data.ResultSet && Array.isArray(result.data.ResultSet)) {
            leaveTypesArray = result.data.ResultSet;
          } else if (result.data.resultSet && Array.isArray(result.data.resultSet)) {
            leaveTypesArray = result.data.resultSet;
          } else if (result.data.data && Array.isArray(result.data.data)) {
            leaveTypesArray = result.data.data;
          } else if (typeof result.data === 'object') {
            for (const key of Object.keys(result.data)) {
              if (Array.isArray(result.data[key]) && result.data[key].length > 0) {
                leaveTypesArray = result.data[key];
                break;
              }
            }
          }

          if (leaveTypesArray.length === 0) {
            setLeaveTypes([]);
            setLeaveTypeInfo('No leave types available for this employee');
            return;
          }

          const mappedTypes = leaveTypesArray.map(item => {
            if (typeof item === 'string' || typeof item === 'number') {
              return { code: String(item), label: String(item), name: String(item), balance: null };
            }
            const code = item.HLT_CODE || item.HLA_LEAVE_TYPE_ID || item.leaveTypeId || item.LeaveTypeId || item.id || item.ID || '';
            const name = item.HLT_NAME || item.label || item.name || String(code);
            const balanceRaw = item.HLA_BALANCE_DAYS;
            const balance = (balanceRaw !== undefined && balanceRaw !== null && balanceRaw !== '') ? Number(balanceRaw) : null;
            const balanceText = balance !== null && !Number.isNaN(balance) ? `${fmtBalance(balance)} day${balance === 1 ? '' : 's'} left` : '';
            return {
              code: String(code).trim(),
              label: balanceText ? `${name} (${balanceText})` : name,
              name,
              balance,
              raw: item,
            };
          });

          const validTypes = mappedTypes.filter(type => type.code);
          if (validTypes.length > 0) {
            setLeaveTypes(validTypes);
            setLeaveTypeInfo('');
            if (!form.p_hlf_leave_type) {
              set('p_hlf_leave_type', validTypes[0].code);
            }
          } else {
            setLeaveTypes([]);
            setLeaveTypeInfo('No valid leave types found for this employee');
          }
        } else {
          setLeaveTypes([]);
          setLeaveTypeInfo(result.message || 'Failed to load leave types');
          if (!result.success) setError(result.message);
        }
      } catch (error) {
        console.error('Error fetching leave types:', error);
        setLeaveTypes([]);
        setLeaveTypeInfo('Error loading leave types. Please try again.');
        setError(error.message || 'Failed to load leave types');
      } finally {
        setLoadingLeaveTypes(false);
      }
    };
    fetchLeaveTypes();
  }, [form.p_hlf_service_no]);

  // Ensure end date matches start date for half day
  useEffect(() => {
    if (form.p_hlf_is_half_day === 'Y' && form.p_hlf_end_date !== form.p_hlf_start_date) {
      setForm(p => ({ ...p, p_hlf_end_date: p.p_hlf_start_date }));
    }
  }, [form.p_hlf_start_date, form.p_hlf_is_half_day]);

  // Validate leave days
  useEffect(() => {
    if (form.p_hlf_is_half_day === 'Y') {
      setLeaveDaysError('');
      return;
    }
    setLeaveDaysError(validateLeaveDays(form.p_hlf_leave_days, selectedLeaveType));
  }, [selectedLeaveType, form.p_hlf_leave_days, form.p_hlf_is_half_day]);

  // ── 9. Handlers ───────────────────────────────────────────────────

  const onEmpSelect = (sno, emp) => {
    const contactNo = fmt(
      emp.p_contact_no ||
      emp.p_mobile_no ||
      emp.p_mobile ||
      emp.HED_CONTACT_NO ||
      emp.HED_MOBILE_NO ||
      emp.HED_MOBILE ||
      ''
    ).replace(/\D/g, '').slice(0, 10);

    setForm(p => ({
      ...p,
      p_hlf_service_no: sno,
      p_hlf_barcode_no: fmt(emp.p_barcode) || fmt(emp.p_barcode_cardno) || '',
      p_hlf_loc_code: fmt(emp.p_location_code) || '',
      p_hlf_dep_code: fmt(emp.p_department_code) || '',
      p_hlf_div_code: fmt(emp.p_division_code) || '',
      p_hlf_contact_no: contactNo,
      p_hlf_leave_type: '',
    }));
    setLeaveDaysError('');
    setDuplicateError('');
    setAttachment(null);
  };

  const toggleHalfDay = () => {
    setForm(p => {
      const next = p.p_hlf_is_half_day === 'Y' ? 'N' : 'Y';
      if (next === 'Y') {
        return {
          ...p,
          p_hlf_is_half_day: 'Y',
          p_hlf_end_date: p.p_hlf_start_date,
          p_hlf_leave_days: '0.5',
          p_hlf_half_day_session: p.p_hlf_half_day_session || 'FIRST_HALF',
        };
      }
      return { ...p, p_hlf_is_half_day: 'N', p_hlf_half_day_session: '' };
    });
  };

  const onLeaveDaysChange = (value) => {
    set('p_hlf_leave_days', value);
    setLeaveDaysError(validateLeaveDays(value, selectedLeaveType));
  };

  const resetForm = () => {
    setForm({
      p_hlf_leaveform_no: generateFormNo(),
      p_hlf_barcode_no: '',
      p_hlf_service_no: '',
      p_hlf_reason: '',
      p_hlf_leave_type: '',
      p_hlf_leave_days: '1',
      p_hlf_start_date: today,
      p_hlf_end_date: today,
      p_hlf_div_code: '',
      p_hlf_dep_code: '',
      p_hlf_loc_code: '',
      p_hlf_contact_no: '',
      p_hlf_attachment_path: '',
      p_acting_officer: '',
      p_supervising_officer: '',
      p_authorizing_officer: '',
      p_hlf_leave_status: 'P',
      p_hlf_approved_status: 'N',
      p_hlf_medical_certificate: 'N',
      p_hlf_generate_email: 'Y',
      p_hlf_year: String(new Date().getFullYear()),
      p_hlf_setoff_status: 'N',
      p_hlf_mc_status: 'N',
      p_hlf_is_half_day: 'N',
      p_hlf_half_day_session: '',
    });
    setAttachment(null);
    setLeaveTypes([]);
    setLeaveTypeInfo('');
    setLeaveDaysError('');
    setDuplicateError('');
    setSuccess('');
    setError('');
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    resetForm();
    navigate('/hrm/leave/approval');
  };

  const handleErrorModalClose = () => {
    setShowErrorModal(false);
    setLoading(false);
  };

  // ── 10. Submit ────────────────────────────────────────────────────

  const handleSubmit = async () => {
    setDuplicateError('');
    setLeaveDaysError('');

    // Validation
    if (!form.p_hlf_leaveform_no) { showError('Leave Form No. required'); return; }
    if (!form.p_hlf_service_no) { showError('Employee required'); return; }
    if (!form.p_hlf_leave_type) { showError('Leave type required'); return; }
    if (!form.p_hlf_start_date) { showError('Start date required'); return; }
    if (!form.p_hlf_end_date) { showError('End date required'); return; }
    if (form.p_hlf_end_date < form.p_hlf_start_date) { showError('End date must be after start date'); return; }
    if (form.p_hlf_is_half_day === 'Y' && !form.p_hlf_half_day_session) { showError('Select First Half or Second Half'); return; }

    const leaveDaysValidationMsg = validateLeaveDays(form.p_hlf_leave_days, selectedLeaveType);
    if (leaveDaysValidationMsg) {
      setLeaveDaysError(leaveDaysValidationMsg);
      showError(leaveDaysValidationMsg);
      return;
    }

    const userContact = form.p_hlf_contact_no.trim();
    const phoneError = validatePhone(userContact);
    if (phoneError) { showError(phoneError); return; }

    const contactNo = userContact || '-';

    if (!userId) { showError('Unable to determine logged-in user. Please log in again.'); return; }

    if (dateRangeError) {
      showError(dateRangeError);
      return;
    }

    // Check for duplicate leave
    try {
      const duplicateCheck = await checkDuplicateLeave(
        form.p_hlf_service_no,
        form.p_hlf_leaveform_no,
        form.p_hlf_start_date,
        form.p_hlf_end_date,
        form.p_hlf_leave_type
      );
      if (duplicateCheck.isDuplicate) {
        if (duplicateCheck.type === 'formNo') setDuplicateError(duplicateCheck.message);
        showError(duplicateCheck.message);
        return;
      }
    } catch (error) {
      console.error('Duplicate check failed:', error);
    }

    let attachmentPath = '';
    if (attachment) {
      attachmentPath = attachment.data || '';
    }

    setLoading(true);
    setError('');
    setSuccess('');
    setShowSuccessModal(false);
    setShowErrorModal(false);

    const masterType = masterLeaveTypes.find(
      (type) =>
        String(type.code).trim().toUpperCase() ===
        String(form.p_hlf_leave_type).trim().toUpperCase()
    );

    if (!masterType?.id) {
      showError(
        `Leave type "${form.p_hlf_leave_type}" is not configured. Please refresh or contact HR.`
      );
      return;
    }

    const leaveTypeId = masterType.id;

    try {
      const result = await dispatch(
        submitLeaveRequest({
          EmpServiceNo: form.p_hlf_service_no,
          FormNo: form.p_hlf_leaveform_no,
          LeaveType: leaveTypeId,
          FromDate: toBackendDate(form.p_hlf_start_date),
          ToDate: toBackendDate(form.p_hlf_end_date),
          IsHalfDay: form.p_hlf_is_half_day,
          HalfDayType: form.p_hlf_is_half_day === 'Y' ? form.p_hlf_half_day_session : '',
          Reason: form.p_hlf_reason,
          ContactNo: contactNo,
          AttachmentPath: attachmentPath,
          UserId: userId,
        })
      ).unwrap();

      let isSuccess = false;
      let responseMessage = '';

      if (typeof result === 'string') {
        responseMessage = result;
        isSuccess = result.toLowerCase().includes('success') || result.toLowerCase().includes('successfully');
      } else if (result && typeof result === 'object') {
        if (result.StatusCode === 200) {
          isSuccess = true;
          responseMessage = result.Result || 'Leave request submitted successfully!';
        } else if (result.StatusCode) {
          isSuccess = false;
          responseMessage = result.Result || result.message || `Failed with status ${result.StatusCode}`;
        } else if (result.success === true) {
          isSuccess = true;
          responseMessage = result.message || 'Leave request submitted successfully!';
        } else if (result.success === false) {
          isSuccess = false;
          responseMessage = result.message || 'Failed to submit leave request';
        } else if (result.message) {
          responseMessage = result.message;
          isSuccess = result.message.toLowerCase().includes('success') || result.message.toLowerCase().includes('successfully');
        } else {
          isSuccess = true;
          responseMessage = 'Leave request submitted successfully!';
        }
      } else if (result) {
        isSuccess = true;
        responseMessage = 'Leave request submitted successfully!';
      } else {
        isSuccess = true;
        responseMessage = 'Leave request submitted successfully!';
      }

      setLoading(false);

      if (isSuccess) {
        setModalMessage(responseMessage);
        setShowSuccessModal(true);
      } else {
        setModalMessage(responseMessage || 'Failed to submit leave request');
        setShowErrorModal(true);
      }

    } catch (e) {
      console.error('Error submitting leave request:', e);
      setLoading(false);

      let errorMsg = typeof e === 'string' ? e : (e?.message || 'Failed to add leave');

      if (errorMsg.toLowerCase().includes('duplicate') ||
        errorMsg.toLowerCase().includes('already exists') ||
        errorMsg.toLowerCase().includes('existing')) {
        errorMsg = 'A leave request with this Form No or date range already exists.';
      }

      if (errorMsg.toLowerCase().includes('success') || errorMsg.toLowerCase().includes('successfully')) {
        setModalMessage(errorMsg);
        setShowSuccessModal(true);
      } else {
        setModalMessage(errorMsg);
        setShowErrorModal(true);
      }
    }
  };


  // ─── Render ──────────────────────────────────────────────────────────

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <SuccessModal isOpen={showSuccessModal} message={modalMessage} onClose={handleSuccessModalClose} />
      <ErrorModal isOpen={showErrorModal} message={modalMessage} onClose={handleErrorModalClose} />

      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 flex flex-col items-center">
            <Loader2 size={48} className="text-primary-500 animate-spin mb-4" />
            <p className="text-gray-700 font-medium">Submitting leave request...</p>
            <p className="text-gray-400 text-sm mt-1">Please wait</p>
          </div>
        </div>
      )}

      <div className="flex-1 overflow-hidden p-4 flex flex-col">
        <div className="w-full h-full flex flex-col justify-between">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-8 flex-1">

            {/* ─── LEFT COLUMN ──────────────────────────────────────── */}
            <div className="space-y-8">

              {/* Employee Section */}
              <div>
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3 flex items-center gap-1.5">
                  <User size={10} /> Employee
                </p>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className={LBL}>Select Employee *</label>
                    <EmpSearch
                      value={form.p_hlf_service_no}
                      onChange={onEmpSelect}
                      employees={employeeOptions}
                    />
                  </div>
                  <div>
                    <label className={LBL}>Service No.</label>
                    <input className={`${INP} bg-gray-100 cursor-not-allowed`} readOnly
                      value={form.p_hlf_service_no} placeholder="Auto-filled on selection" />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <div>
                    <label className={LBL}>Barcode No.</label>
                    <input className={INP} placeholder="Auto-filled or enter manually"
                      value={form.p_hlf_barcode_no} onChange={e => set('p_hlf_barcode_no', e.target.value)} />
                  </div>
                </div>
              </div>

              {/* Leave Identification */}
              <div>
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3 flex items-center gap-1.5">
                  <Hash size={10} /> Leave Identification
                </p>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className={LBL}>Leave Form No. *</label>
                    <div className="relative">
                      <input
                        className={`${INP} ${duplicateError ? 'border-red-300 focus:ring-red-200 focus:border-red-400' : ''} ${isValidatingFormNo ? 'pr-8' : ''}`}
                        placeholder="Enter Leave Form No"
                        value={form.p_hlf_leaveform_no}
                        onChange={e => set('p_hlf_leaveform_no', e.target.value)}
                      />
                      {/* Regenerate Button */}
                      <button
                        type="button"
                        onClick={() => set('p_hlf_leaveform_no', generateFormNo())}
                        className="absolute right-10 top-1/2 -translate-y-1/2 text-gray-400 hover:text-primary-600 transition-colors"
                        title="Regenerate Form Number"
                      >
                        <RefreshCw size={16} className="hover:rotate-180 transition-transform duration-300" />
                      </button>
                      {isValidatingFormNo && (
                        <div className="absolute right-3 top-1/2 -translate-y-1/2">
                          <Loader2 size={16} className="animate-spin text-primary-500" />
                        </div>
                      )}
                      {!isValidatingFormNo && form.p_hlf_leaveform_no && !duplicateError && form.p_hlf_service_no && (
                        <div className="absolute right-3 top-1/2 -translate-y-1/2">
                          <CheckCircle size={16} className="text-emerald-500" />
                        </div>
                      )}
                    </div>
                    {duplicateError ? (
                      <p className="mt-1 text-[11px] text-red-600 flex items-center gap-1">
                        <AlertCircle size={11} className="shrink-0" />
                        {duplicateError}
                      </p>
                    ) : (
                      !isValidatingFormNo && form.p_hlf_leaveform_no && form.p_hlf_service_no && (
                        <p className="mt-1 text-[11px] text-emerald-600 flex items-center gap-1">
                          <CheckCircle size={11} className="shrink-0" />
                          Form No is available
                        </p>
                      )
                    )}
                  </div>
                  <div>
                    <label className={LBL}>Leave Year</label>
                    <div className="relative">
                      <select
                        className={`${SEL} pr-9`}
                        value={form.p_hlf_year}
                        onChange={e => set('p_hlf_year', e.target.value)}
                      >
                        {getYearOptions().map(year => (
                          <option key={year} value={String(year)}>{year}</option>
                        ))}
                      </select>
                      <ChevronDown
                        size={15}
                        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
                      />
                    </div>
                  </div>
                </div>
              </div>

            </div>

            {/* ─── RIGHT COLUMN ─────────────────────────────────────── */}
            <div className="space-y-8">

              {/* Leave Details */}
              <div>
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3 flex items-center gap-1.5">
                  <Calendar size={10} /> Leave Details
                </p>

                <div className="mb-3">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className={LBL}>Leave Type *</label>
                      <select
                        className={`${SEL} ${!form.p_hlf_service_no ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''}`}
                        value={form.p_hlf_leave_type}
                        onChange={e => set('p_hlf_leave_type', e.target.value)}
                        disabled={!form.p_hlf_service_no || loadingLeaveTypes}
                      >
                        <option value="">Select Leave Type</option>
                        {leaveTypes.map((type, index) => (
                          <option
                            key={`${type.code}-${index}`}
                            value={type.code}
                            disabled={type.balance !== null && type.balance <= 0}
                          >
                            {type.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className={LBL}>Leave Days *</label>
                      <input
                        type="number"
                        step="0.5"
                        min="0.5"
                        max={selectedLeaveType && selectedLeaveType.balance !== null ? selectedLeaveType.balance : undefined}
                        className={`${INP} ${form.p_hlf_is_half_day === 'Y' ? 'bg-gray-100 cursor-not-allowed' : ''} ${leaveDaysError ? 'border-red-300 focus:ring-red-200 focus:border-red-400' : ''}`}
                        readOnly={form.p_hlf_is_half_day === 'Y'}
                        value={form.p_hlf_leave_days}
                        onChange={e => onLeaveDaysChange(e.target.value)}
                      />
                      {leaveDaysError && form.p_hlf_is_half_day !== 'Y' && (
                        <p className="mt-1 text-[11px] text-red-600 flex items-center gap-1">
                          <AlertCircle size={11} className="shrink-0" />
                          {leaveDaysError}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Leave Type Balance Info */}
                  {form.p_hlf_leave_type && (() => {
                    const selectedType = selectedLeaveType;
                    if (!selectedType || selectedType.balance === null) return null;
                    const low = selectedType.balance <= 0;
                    return (
                      <div className={`mt-2 flex items-center gap-2 px-3 py-2 rounded-lg text-[11px] ${low ? 'bg-red-50 border border-red-200 text-red-700' : 'bg-emerald-50 border border-emerald-200 text-emerald-700'
                        }`}>
                        <BadgeCheck size={13} className="shrink-0" />
                        <span>
                          {selectedType.name}: {fmtBalance(selectedType.balance)} day{selectedType.balance === 1 ? '' : 's'} remaining
                          {low ? ' — no balance left' : ''}
                        </span>
                      </div>
                    );
                  })()}

                  {/* Leave Type Info */}
                  {leaveTypeInfo && (
                    <div className={`mt-2 flex items-center gap-2 px-3 py-2 rounded-lg text-[11px] ${!form.p_hlf_service_no
                      ? 'bg-emerald-50 border border-emerald-200 text-emerald-700'
                      : 'bg-gray-50 border border-gray-200 text-gray-600'
                      }`}>
                      <Info size={13} className="shrink-0" />
                      <span>{leaveTypeInfo}</span>
                      {loadingLeaveTypes && <Loader2 size={13} className="animate-spin ml-auto" />}
                    </div>
                  )}
                </div>

                {/* Date Fields - Increased width */}
                <div className="grid grid-cols-2 gap-6 mb-3">
                  <DatePickerWithFormat
                    label="Start Date"
                    value={form.p_hlf_start_date}
                    onChange={(date) => set('p_hlf_start_date', date)}
                    required={true}
                    placeholder="2026/09/03"
                  />
                  <DatePickerWithFormat
                    label="End Date"
                    value={form.p_hlf_end_date}
                    onChange={(date) => set('p_hlf_end_date', date)}
                    required={true}
                    disabled={form.p_hlf_is_half_day === 'Y'}
                    placeholder="2026/09/03"
                  />
                </div>

                {dateRangeError && (
                  <div className="mb-3 flex items-start gap-2 px-3 py-2 rounded-lg text-[11px] bg-red-50 border border-red-200 text-red-700">
                    <AlertCircle size={13} className="shrink-0 mt-0.5" />
                    <span>{dateRangeError}</span>
                  </div>
                )}

                {/* Half Day Toggle */}
                <div className="mb-3 p-3 bg-gray-50 border border-gray-200 rounded-lg">
                  <label className="flex items-center gap-2.5 cursor-pointer select-none">
                    <button
                      type="button"
                      onClick={toggleHalfDay}
                      className={`relative w-11 h-6 rounded-full transition-colors shrink-0 flex items-center ${form.p_hlf_is_half_day === 'Y' ? 'bg-primary-500' : 'bg-gray-200'
                        }`}
                    >
                      <span className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow transition-transform ${form.p_hlf_is_half_day === 'Y' ? 'translate-x-6' : 'translate-x-1'
                        }`} />
                    </button>
                    <Sun size={12} className="text-gray-500 shrink-0" />
                    <span className="text-[12px] text-gray-700 font-medium">Is Half Day</span>
                  </label>

                  {form.p_hlf_is_half_day === 'Y' && (
                    <div className="mt-3 flex gap-4">
                      {[
                        ['FIRST_HALF', 'First Half'],
                        ['SECOND_HALF', 'Second Half'],
                      ].map(([val, label]) => (
                        <label key={val} className="flex items-center gap-1.5 text-[12px] text-gray-700 cursor-pointer">
                          <input
                            type="radio"
                            name="half_day_session"
                            className="accent-primary-500 w-3.5 h-3.5"
                            checked={form.p_hlf_half_day_session === val}
                            onChange={() => set('p_hlf_half_day_session', val)}
                          />
                          {label}
                        </label>
                      ))}
                    </div>
                  )}
                </div>

                {/* Reason */}
                <div className="flex-1 flex flex-col">
                  <label className={LBL}>Reason</label>
                  <textarea
                    className={`${INP} flex-1 min-h-[120px] resize-none`}
                    placeholder="Reason for leave..."
                    value={form.p_hlf_reason}
                    onChange={e => set('p_hlf_reason', e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ─── ACTION BUTTONS ──────────────────────────────────────── */}
          <div className="flex gap-3 pt-4">
            <button
              onClick={() => navigate('/hrm/leave')}
              className="px-6 py-2.5 text-sm font-medium text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-100 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={loading || !!duplicateError || isValidatingFormNo || !!dateRangeError}
              className="px-8 py-2.5 text-sm font-bold text-white bg-primary-500 hover:bg-primary-600 rounded-xl transition-colors disabled:opacity-60 flex items-center gap-2"
            >
              Submit Leave Request
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}